/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type TradingPositionGetPnlPeriod = (typeof TradingPositionGetPnlPeriod)[keyof typeof TradingPositionGetPnlPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradingPositionGetPnlPeriod = {
  '1D': '1D',
  '1W': '1W',
  '1M': '1M',
  ALL: 'ALL',
} as const;
